'use client'

import TrueLayerLogo from '@public/images/logos/truelayer-white.png'
import Image from 'next/image'

import CustomerQuote from '@/components/CustomerQuote'

const TrueLayerCustomerQuote = () => {
    return (
        <CustomerQuote
            light={true}
            backgroundImageSrc={'/images/customer-quotes/truelayer-quote-desktop.png'}
            mobileBackgroundImageSrc={'/images/customer-quotes/truelayer-quote-mobile.png'}
            logo={<Image src={TrueLayerLogo} height={28} width={163.95} alt={`TrueLayer Logo`} />}
            text={
                <>
                    It is essential that every business becomes more climate friendly. For
                    TrueLayer, doing right for our planet is important, an ethos shared by both our
                    customers and our employees.
                    <br />
                    <br />
                    Lune was the easiest way for our business to take the first steps, have a real
                    impact, and continue building the future of the payments industry.
                </>
            }
            avatar={{
                title: 'Francesco Simoneschi',
                subtitle: 'Founder and CEO at TrueLayer',
                imageSrc: '/images/avatars/truelayer-customer-quote-avatar.png',
            }}
        />
    )
}

export default TrueLayerCustomerQuote
